import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { SalespeopleDataTable } from "./salespeople-data-table";

export default function SalespeopleListView() {
  usePageTitle("Rep List");

  return (
    <ListPageLayout pageType="salespeople::list" title="Rep List">
      <SalespeopleDataTable />
    </ListPageLayout>
  );
}
